import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class CreateRecipeModal extends React.PureComponent {
  render() {
    return (
      <Dialog open={this.props.isOpen} onOpenChange={this.props.onClose}>
        <DialogContent size="xl">
          <DialogHeader>
            <DialogTitle>{this.props.title}</DialogTitle>
          </DialogHeader>
          {this.props.children}
        </DialogContent>
      </Dialog>
    );
  }
}
